import {
    useCallback,
    useState,
    Dispatch,
    SetStateAction,
} from 'react';

type useToggleReturn = [
    boolean,
    () => void,
    Dispatch<SetStateAction<boolean>>,
]

export const useToggle = (defaultValue: boolean = false): useToggleReturn => {
    const [toggled, setToggled] = useState<boolean>(defaultValue);

    const toggleValue = useCallback(() => setToggled(!toggled), [toggled, setToggled]);

    return [toggled, toggleValue, setToggled];
};
